import React from 'react';
import { useParams } from 'react-router-dom';
import { useRestaurantByPlaceId } from '../hooks/useRestaurantByPlaceId';
import RestaurantDetailView from './RestaurantDetailView';

// /place/:placeId — restaurant detail keyed by the canonical Google place_id
// (the homepage links here). Resolution differs from /restaurant/:slug, but the
// rendered page is identical — see RestaurantDetailView.
const PlaceDetailPage: React.FC = () => {
  const { placeId = '' } = useParams<{ placeId: string }>();
  const { detail, isLoaded, error } = useRestaurantByPlaceId(placeId);

  return <RestaurantDetailView detail={detail} isLoaded={isLoaded} error={error} />;
};

export default PlaceDetailPage;
